import { WidgetMetadata } from 'components/Dashboard/types';

export enum GreenPlatesWidgetsEnum {
  MissingGreenPlates = 'MissingGreenPlates',
  GreenPlatesList = 'GreenPlatesList',
}

export const UPDATE_INTERVAL = 15000; // 15sek

export const DefaultGreenPlatesWidgets: WidgetMetadata<GreenPlatesWidgetsEnum>[] =
  [
    {
      identifier: GreenPlatesWidgetsEnum.MissingGreenPlates,
      shortTitle: 'Rapporterad grönskylt',
      longTitle: 'Rapporterad grönskylt (saknad eller ej verifierad)',
      active: true,
    },
    {
      identifier: GreenPlatesWidgetsEnum.GreenPlatesList,
      shortTitle: 'Grönskyltar',
      longTitle: 'Grönskyltar',
      active: true,
    },
  ];

export const LongTitles: Record<GreenPlatesWidgetsEnum, string> =
  DefaultGreenPlatesWidgets.reduce(
    (titles, widget) => ({
      ...titles,
      [widget.identifier]: widget.longTitle,
    }),
    {} as Record<GreenPlatesWidgetsEnum, string>
  );
